export default __webpack_public_path__ + "static/media/aboutImage.72fdc58f.png";